import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer, BringzzIcon, BringzzBoxSlider, BringzzText, BringzzImage
} from "@bringzz/components";
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import ProductExample from 'assets/images/ProductExample.png';
import { useTranslation } from 'react-i18next';

const SearchPage = () => {
    const { t } = useTranslation();
    const { backPress } = useNavigation();
    const { navigate } = useNavigation();
    const { '*': searchQuery } = useParams();

    const types = [
        t('component.search.types.all'),
        t('component.search.types.products'),
        t('component.search.types.posts'),
        t('component.search.types.categories'),
        t('component.search.types.pages'),
        t('component.search.types.orders')
    ]

    const initialProducts = [
        {
            integrationId: '1',
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            integrationId: '2',
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            integrationId: '3',
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            integrationId: '4',
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
    ];
    const [products, setProducts] = useState(initialProducts);

    const initialPages = [
        {
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
        {
            img: ProductExample,
            companyName: t('component.search.placeholders.company_name'),
            name: t('component.search.placeholders.product_name'),
            marked: false
        },
    ];
    const [pages, setPages] = useState(initialPages);

    const initialOrders = [
        {
            img: ProductExample,
            date: "19/02/2024",
            invoice: t('component.search.placeholders.order_number', { number: "123456" }),
            marked: false
        },
        {
            img: ProductExample,
            date: "19/02/2024",
            invoice: t('component.search.placeholders.order_number', { number: "12345" }),
            marked: false
        },
        {
            img: ProductExample,
            date: "19/02/2024",
            invoice: t('component.search.placeholders.order_number', { number: "1234" }),
            marked: false
        },
        {
            img: ProductExample,
            date: "19/02/2024",
            invoice: t('component.search.placeholders.order_number', { number: "123" }),
            marked: false
        },
    ];
    const [orders, setOrders] = useState(initialOrders);

    const initialPosts = [
        {
            img: ProductExample,
            pharmacyName: t('component.search.placeholders.pharmacy_name'),
            title: t('component.search.placeholders.post_title'),
            marked: false
        },
        {
            img: ProductExample,
            pharmacyName: "Bayer Pharmaceutics",
            title: t('component.search.placeholders.post_title'),
            marked: false
        },
        {
            img: ProductExample,
            pharmacyName: "Med Pharma Service GmbH",
            title: t('component.search.placeholders.post_title'),
            marked: false
        },
        {
            img: ProductExample,
            pharmacyName: "Bort GmbH",
            title: t('component.search.placeholders.post_title'),
            marked: false
        },
    ];
    const [posts, setPosts] = useState(initialPosts);

    const categories = [
        {
            name: t('component.search.categories.rx_medicine.name'),
            shortName: t('component.search.categories.rx_medicine.short'),
            img: "/images/5.jpg",
            icon: <BringzzIcon
                size="25"
                icon="IconPrescriptionDocument"
                folder="HealthIcons"
            />
        },
        {
            name: t('component.search.categories.otc_medicine.name'),
            shortName: t('component.search.categories.otc_medicine.short'),
            img: "/images/7.jpg",
            icon: <BringzzIcon
                size="25"
                icon="IconTelemedicine"
                folder="HealthIcons"
            />
        },
        {
            name: t('component.search.categories.medical_devices.name'),
            shortName: t('component.search.categories.medical_devices.short'),
            img: "/images/8.jpg",
            icon: <BringzzIcon
                size="25"
                icon="IconThermometer"
                folder="HealthIcons"
            />
        },
        {
            name: t('component.search.categories.supplements.name'),
            shortName: t('component.search.categories.supplements.short'),
            img: "/images/4.jpg",
            icon: <BringzzIcon
                size="25"
                icon="IconBlisterPillsOvalX16"
                folder="HealthIcons"
            />
        }
    ]

    const toggleBookmark = (index, type) => {
        if (type == "products") {
            setProducts(prevProducts => prevProducts.map((product, i) =>
                i === index ? { ...product, marked: !product.marked } : product
            ));
        } else if (type == "posts") {
            setPosts(prevPosts => prevPosts.map((post, i) =>
                i === index ? { ...post, marked: !post.marked } : post
            ));
        } else if (type == "pages") {
            setPages(prevPages => prevPages.map((page, i) =>
                i === index ? { ...page, marked: !page.marked } : page
            ));
        } else if (type == "orders") {
            setOrders(prevOrders => prevOrders.map((order, i) =>
                i === index ? { ...order, marked: !order.marked } : order
            ));
        }

    };

    return (
        <BringzzPageContainer
            className="bg-white pb-32"
            authenticated={false}
            footerHover={true}
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: searchQuery
            }}
        >
            <div className='pt-2'>
                <div className='pl-6'>
                    <BringzzBoxSlider className='pr-4 space-x-2'>
                        {types.map((type, index) => (
                            <div key={index} className={classNames('bg-sand rounded-lg py-2 px-4 cursor-pointer', index === 0 && "!bg-magic-lilac")}>
                                <BringzzText tag='h4'>{type}</BringzzText>
                            </div>
                        ))}
                    </BringzzBoxSlider>
                </div>
                <div className='px-6 mt-1'>
                    <div className='flex justify-between items-center'>
                        <BringzzText tag='h2'>Products</BringzzText>
                        <BringzzText tag='h4' className='text-magic-lilac cursor-pointer'>Show All</BringzzText>
                    </div>
                    <div className='mt-1'>
                        {products.map((product, index) => (
                            <div key={index} className='flex items-center border-b py-2'>
                                <BringzzImage 
                                    src={product.img} 
                                    className='h-14 w-14 mr-2 cursor-pointer' 
                                    onClick={() => navigate(`/product/details/${product.integrationId}`)}
                                />
                                <div className='flex flex-col flex-grow cursor-pointer' onClick={() => navigate(`/product/details/${product.integrationId}`)}>
                                    <BringzzText tag='h3'>{product.companyName}</BringzzText>
                                    <BringzzText tag='h3' className='font-normal'>{product.name}</BringzzText>
                                </div>
                                <BringzzIcon
                                    size="22"
                                    icon="IconBookmark"
                                    folder="LineIcons"
                                    className={classNames("cursor-pointer", product.marked && "text-magic-lilac")}
                                    onClick={() => toggleBookmark(index, "products")}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='px-6 mt-4'>
                    <div className='flex justify-between items-center'>
                        <BringzzText tag='h2'>Posts</BringzzText>
                        <BringzzText tag='h4' className='text-magic-lilac cursor-pointer'>Show All</BringzzText>
                    </div>
                    <div className='mt-1'>
                        {posts.map((post, index) => (
                            <div key={index} className='flex items-center border-b py-2'>
                                <BringzzImage src={post.img} className='h-14 w-14 mr-2' />
                                <div className='flex flex-col flex-grow'>
                                    <BringzzText tag='h3'>{post.pharmacyName}</BringzzText>
                                    <BringzzText tag='h3' className='font-normal'>{post.title}</BringzzText>
                                </div>
                                <BringzzIcon
                                    size="22"
                                    icon="IconBookmark"
                                    folder="LineIcons"
                                    className={classNames("cursor-pointer", post.marked && "text-magic-lilac")}
                                    onClick={() => toggleBookmark(index, "posts")}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='px-6 mt-4'>
                    <div className='flex justify-between items-center'>
                        <BringzzText tag='h2'>Categories</BringzzText>
                        <BringzzText tag='h4' className='text-magic-lilac cursor-pointer'>Show All</BringzzText>
                    </div>
                    <div className='mt-1'>
                        {categories.map((category, index) => {
                            return <div key={index} className='flex items-center h-12 border-b justify-between cursor-pointer'>
                                <div className='flex space-x-2 items-center'>
                                    {category.icon}
                                    <BringzzText tag='h3'>{category.shortName}</BringzzText>
                                </div>
                                <BringzzIcon
                                    size="16"
                                    icon="IconChevronRight"
                                    folder="LineIcons"
                                />
                            </div>
                        })}
                    </div>
                </div>
                <div className='px-6 mt-4'>
                    <div className='flex justify-between items-center'>
                        <BringzzText tag='h2'>Pages</BringzzText>
                        <BringzzText tag='h4' className='text-magic-lilac cursor-pointer'>Show All</BringzzText>
                    </div>
                    <div className='mt-1'>
                        {pages.map((page, index) => (
                            <div key={index} className='flex items-center border-b py-2'>
                                <BringzzImage src={page.img} className='h-14 w-14 mr-2' />
                                <div className='flex flex-col flex-grow'>
                                    <BringzzText tag='h3'>{page.companyName}</BringzzText>
                                    <BringzzText tag='h3' className='font-normal'>{page.name}</BringzzText>
                                </div>
                                <BringzzIcon
                                    size="22"
                                    icon="IconBookmark"
                                    folder="LineIcons"
                                    className={classNames("cursor-pointer", page.marked && "text-magic-lilac")}
                                    onClick={() => toggleBookmark(index, "pages")}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className='px-6 mt-4'>
                    <div className='flex justify-between items-center'>
                        <BringzzText tag='h2'>Orders</BringzzText>
                        <BringzzText tag='h4' className='text-magic-lilac cursor-pointer'>Show All</BringzzText>
                    </div>
                    <div className='mt-1'>
                        {orders.map((order, index) => {
                            return (<div key={index} className='flex items-center border-b py-2'>
                                <BringzzImage src={order.img} className='h-14 w-14 mr-2' />
                                <div className='flex flex-col flex-grow'>
                                    <BringzzText tag='h3'>{order.date}</BringzzText>
                                    <BringzzText tag='h3' className='font-normal'>{order.invoice}</BringzzText>
                                </div>
                                <BringzzIcon
                                    size="22"
                                    icon="IconBookmark"
                                    folder="LineIcons"
                                    className={classNames("cursor-pointer", order.marked && "text-magic-lilac")}
                                    onClick={() => toggleBookmark(index, "orders")}
                                />
                            </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default SearchPage;
